export const pwaStoragePrefix = '_bettercampus_storage_';
